import { defineLocale } from "../../registry";

const create = defineLocale({
  ru: {
    "create.field.title": "Название",
    "create.field.category": "Категория",
    "create.category.placeholder": "Выберите категорию",
    "create.submit": "Создать Pick",
    "create.submitting": "Создаём…",
    "create.error.titleRequired": "Введите название",
    "create.error.titleTooLong": "Название не длиннее {max} символов",
    "create.error.categoryRequired": "Выберите категорию",
    "create.error.invalid": "Значение не принято сервером",
    "create.categories.empty":
      "Категорий пока нет. Добавьте их в разделе «Категории и иконки».",
  },
  en: {
    "create.field.title": "Title",
    "create.field.category": "Category",
    "create.category.placeholder": "Choose a category",
    "create.submit": "Create pick",
    "create.submitting": "Creating…",
    "create.error.titleRequired": "Enter a title",
    "create.error.titleTooLong": "Title must be at most {max} characters",
    "create.error.categoryRequired": "Choose a category",
    "create.error.invalid": "The server did not accept this value",
    "create.categories.empty":
      "There are no categories yet. Add them under Categories & Icons.",
  },
});

export default create;
